module.exports = __webpack_public_path__ + "fonts/Manrope-600-latin18.02fde8a.woff2";